const { departmentList } = require("constants/department");

const initialState = {
  departmentList: {},
};

const department = (state = initialState, action) => {
  switch (action.type) {
    case departmentList:
      return { ...state, departmentList: action.payload };

    default:
      return state;
  }
};
export default department;
